import { keyframes, styled } from '@mui/system'
import { AnimatedDiv } from '@/ui/components/animatedDiv/animatedDiv.styles'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

const spin = keyframes`
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
`

export const MDRMainTitle = styled('div')`
    display: flex;
    gap: 12px;
    margin: 32px 0;
    align-items: center;
`

export const Flex = styled('div')`
    display: flex;
    align-content: center;
    align-items: center;
    gap: 8px;
`
export const RightContainer = styled('div')`
    padding: 12px 38px;
`
export const LeftContainer = styled('div')`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;
`

export const FlexAll = styled('div')`
    flex: 1;
`

export const MdrTabLabel = styled(Typography)<{
    active: boolean
    activeColor: string
    inactiveColor: string
}>`
    color: ${({ active, activeColor, inactiveColor }) =>
        active ? activeColor : inactiveColor};
`

export const fadeAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.5 },
}

export const slideAnimation = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
    transition: { duration: 0.5 },
}

export const DemoOverlay = styled(AnimatedDiv)<{ theme?: TTheme }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme?.colors.semantic.mdrDemoOverlay};
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(1px);
`

export const DemoModal = styled(AnimatedDiv)<{ theme?: TTheme }>`
    background: ${({ theme }) => theme?.colors.semantic.backgroundSecondary};
    position: absolute;
    border-radius: 4px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    padding: 25px 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 410px;
    top: 200px;
`

export const TimeRangeActivator = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const LoadingMoreIndicator = styled('div')`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
`

export const Spinner = styled('div')<{ theme?: TTheme }>`
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme?.colors.greys[200]};
    border-top-color: ${({ theme }) => theme?.colors.primary[600]};
    animation: ${spin} 0.8s linear infinite;
    flex-shrink: 0;
`
